import { ISubmitResponse } from '@interfaces/models/ISubmitResponse';
import { VgEmploymentState } from '@interfaces/models/open-account-mfes/employment-mfe.model';
import { ValidationStatus } from '@interfaces/models/open-account-mfes/mfe-common.interfaces';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';

export interface IOpenAccountState {
  openAccountResponse: ISubmitResponse;
  submitMetricsProcessingId: string;
  settlementFundChoice: SettlementFundAoAEnum | null;
  isEditingProfile: boolean;
  isEditingEmployment: boolean;
  isEditingAccount: boolean;
  employmentMfeData: {
    [ownerIndex: number]: Partial<VgEmploymentState>;
  };
  employmentMfeValidationStatus: {
    [ownerIndex: number]: ValidationStatus;
  };
}
